// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Slick dots */
.slick-dots {
  bottom: 180px;
}

.slick-dots li {
  margin: 0 !important;
}

.slick-dots li button:before {
  font-family: "slick";
  font-size: 11px;
  line-height: 20px;
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  content: "•";
  text-align: center;
  opacity: 0.5;
  color: white;
  -webkit-font-smoothing: antialiased;
  transition: opacity 0.3s ease, color 0.3s ease;
}

.slick-dots li.slick-active button:before {
  opacity: 0.75;
  color: rgb(0, 183, 255);
}

/* Input styles */
.input--notfall {
  width: 100%;
  height: 19px;
  background-color: rgb(0, 0, 0);
  color: white;
  margin-bottom: 29px;
  font-size: 14px;
  line-height: 16.94px;
  font-weight: 400;
  font-family: "Inter", sans-serif;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.input--notfall.active {
  background-color: #141414;
  color: white;
}

/* General textarea styles */
.textarea {
  text-align: center;
  width: 100%;
  background-color: rgb(0, 0, 0);
  color: white;
  font-size: 17px;
  line-height: 25px;
  font-weight: 400;
  font-family: "Inter", sans-serif;
  resize: none;
  overflow-y: auto;
  transition: all 0.3s ease;
}

.textarea.active {
  padding-top: 17px;
  background-color: #141414;
  color: white;
}

/* Specific textarea modifiers */
.textarea--notfall {
  max-height: 300px; /* Ограничение по высоте */
}

.textarea--allergia {
  min-height: 82px;
}

/* Disabled textarea */
textarea[disabled] {
  color: #ffffff;
}

.select-option {
  color: #000000;
}
`, "",{"version":3,"sources":["webpack://./src/Containers/Notfall/style.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gCAAgC;EAChC,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,iBAAiB,EAAE,0BAA0B;AAC/C;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Slick dots */\n.slick-dots {\n  bottom: 180px;\n}\n\n.slick-dots li {\n  margin: 0 !important;\n}\n\n.slick-dots li button:before {\n  font-family: \"slick\";\n  font-size: 11px;\n  line-height: 20px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 20px;\n  height: 20px;\n  content: \"•\";\n  text-align: center;\n  opacity: 0.5;\n  color: white;\n  -webkit-font-smoothing: antialiased;\n  transition: opacity 0.3s ease, color 0.3s ease;\n}\n\n.slick-dots li.slick-active button:before {\n  opacity: 0.75;\n  color: rgb(0, 183, 255);\n}\n\n/* Input styles */\n.input--notfall {\n  width: 100%;\n  height: 19px;\n  background-color: rgb(0, 0, 0);\n  color: white;\n  margin-bottom: 29px;\n  font-size: 14px;\n  line-height: 16.94px;\n  font-weight: 400;\n  font-family: \"Inter\", sans-serif;\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.input--notfall.active {\n  background-color: #141414;\n  color: white;\n}\n\n/* General textarea styles */\n.textarea {\n  text-align: center;\n  width: 100%;\n  background-color: rgb(0, 0, 0);\n  color: white;\n  font-size: 17px;\n  line-height: 25px;\n  font-weight: 400;\n  font-family: \"Inter\", sans-serif;\n  resize: none;\n  overflow-y: auto;\n  transition: all 0.3s ease;\n}\n\n.textarea.active {\n  padding-top: 17px;\n  background-color: #141414;\n  color: white;\n}\n\n/* Specific textarea modifiers */\n.textarea--notfall {\n  max-height: 300px; /* Ограничение по высоте */\n}\n\n.textarea--allergia {\n  min-height: 82px;\n}\n\n/* Disabled textarea */\ntextarea[disabled] {\n  color: #ffffff;\n}\n\n.select-option {\n  color: #000000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
